<template>
	<div style="background: #f5f5f5">
		<div class="header flex">
			<div class="flex header-back align-items" @click="back()">
				<i class="el-icon-arrow-left" style="color: #666"></i>
				<span>{{$t('Preview.ExitPreview')}}</span>
			</div>
			<div v-if="isBank" style="flex: 1; color: #666;margin-right: 124px;" class="flex align-items justify-content">{{$t('Preview.Tip')}}</div>
		</div>
		<div class="tab flex justify-content">
			<el-radio-group v-model="tabPosition">
				<el-radio-button label="phone">
					<i class="el-icon-mobile-phone"></i>
					{{ $t('Preview.MobilePhone') }}
				</el-radio-button>
				<el-radio-button label="computer">
					<i class="el-icon-monitor"></i>
					{{$t('Preview.Computer')}}
				</el-radio-button>
			</el-radio-group>
		</div>
		<div class="tab flex justify-content" v-if="yq != 0" @click="yytemplate()"><el-button class="tab_button">{{$t('Preview.ReferenceThisTemplate')}}</el-button></div>
		<!-- <div style="width: 100%; height: 150px"></div> -->
		<!-- 手机 -->
		<div class="phoneBox flex justify-content" v-if="tabPosition == 'phone'">
			<div class="phone-bj">
				<div class="phone-bj-box"><UserAnswer :isBank="isBank" :isPreviewPc="1" :key="1"></UserAnswer></div>
			</div>
		</div>
		<!-- pc -->
		<div class="computerBox" v-else-if="tabPosition == 'computer'">
			<div class="c_box"><UserAnswer :isBank="isBank" :isPreviewPc="2" :key="2"></UserAnswer></div>
		</div>
	</div>
</template>

<script>
import ElCheckbox from 'element-ui/packages/checkbox/src/checkbox';
import ElInput from 'element-ui/packages/input/src/input';
import qs from 'qs';
import * as qiniu from 'qiniu-js';
import draggable from 'vuedraggable';

import UserAnswer from './userAnswer.vue';
export default {
	name: 'Preview',
	components: {
		UserAnswer
	},
	data() {
		return {
			id: '',
			tabPosition: 'phone',
			isPreviewPc: 1,
			yq: 0,
			height: `${document.documentElement.clientHeight - 190}`,
			isBank: false
		};
	},
	created() {
		this.id = this.$route.query.id;
		this.yq = this.$route.query.yq || 0;
		// this.isBank = this.$route.query.isBank || false
		if (this.$route.query.isBank) {
			this.isBank = true;
		} else {
			this.isBank = false;
		}
		this.tabPosition = this.$route.query.tabPosition || 'phone';
	},
	mounted() {},
	watch: {},
	methods: {
		back() {
			this.$router.go(-1);
		},
		yytemplate() {
			const loading = this.$loading({
				lock: true,
				text: this.$t('Preview.InReference'),
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			// ?id=${this.id}
			let that = this;
			let params = {
				url: `${this.$config.service.quoteTemp}?id=${this.id}`,
				method: 'GET',
				data: {},
				that: this,
				cb(res) {
					if (res.code == 0) {
						let wid = res.message;
						sessionStorage.setItem('wid', wid);
						setTimeout(() => {
							that.$router.replace({ path: '/wjedit1', id: wid });
							loading.close();
						}, 400);
					} else {
						loading.close();
						that.preview = {};
					}
				}
			};
			that.$util.request(params);
		}
	}
};
</script>

<style scoped lang="scss">
/deep/.CrossBlank .el-input__inner {
	border: 0px !important;
}
/deep/.share {
	display: none;
}
.tableColl tr {
	border-bottom: 0px;
}
.img_bor {
	float: left;
	margin-right: 10px;
	margin-bottom: 15px;
	width: 146px;
	height: 220px;
	border: 1px solid #ccc;
	border-radius: 3px;
}
.img_bor img {
	width: 146px;
	height: 146px;
}
.img_bor el-radio {
	margin-left: 15px;
	margin-top: 20px;
}
.questionImage_box {
	width: 800px;
	height: auto;
	margin: 0 auto;
}
.questCity .el-input {
	display: flex;
}
/deep/.questCity .el-input__inner {
	width: 120px !important;
}
.setStyle {
	width: 400px;
	height: 76px;
	border: 1px solid #ccc;
	margin-top: 20px;
	border-radius: 3px;
}
.setStyle:hover {
	border: 1px solid #ccc;
}
.questiontime {
	display: flex;
}
/*输入框input*/
/deep/.questiontime .el-input__inner {
	width: 200px !important;
	margin-right: 10px;
	margin-left: 10px;
}
.startsort-btn {
	width: 100px;
	height: 40px;
	border: none;
	background: #0080ff;
	color: #fff;
	border-radius: 5px;
	margin-bottom: 20px;
}
td input {
	border: none;
}
td input:hover {
	border: none;
}
.sortBox {
	width: 530px;
	height: 44px;
	display: flex;
	align-self: center;
	border: 1px solid #ccc;
}
.sortBox .numsort {
	width: 70px;
	text-align: center;
	border-right: 1px solid #ccc;
	display: flex;
	justify-content: center;
	align-items: center;
}
.numsort p {
	width: 20px;
	height: 20px;
	text-align: center;
	line-height: 20px;
	background: #0080ff;
	color: #fff;
	border-radius: 50%;
}
.sorticon {
	width: 110px;
	display: flex;
	justify-content: center;
	align-self: center;
}
.sorticon span {
	width: 20px;
	height: 20px;
	line-height: 20px;
	text-align: center;
	background: #0080ff;
	color: #fff;
	border-radius: 2px;
}
.textsort {
	width: 350px;
	text-align: center;
	border-right: 1px solid #ccc;
}
.Multblank {
	display: flex;
	align-items: center;
	margin-top: 15px;
}
.Multblank p {
	width: 50px;
}
.Rectinput {
	width: 120px;
	height: 20px;
	border: 1px solid #ccc;
}
.Rectinput:hover {
	border: none !important;
}
.ul-rate {
	display: flex;
	justify-content: space-around;
	align-items: center;
}
.baiduMap-btn {
	width: 450px;
	height: 38px;
	border: 1px solid #ccc;
	background-color: #fff;
	display: flex;
	justify-content: center;
	align-items: center;
}
.baiduMap-btn:focus {
	border: 1px solid #0080ff !important;
	color: #0080ff;
}
.baiduMap-btn i {
	font-size: 18px;
}
// /deep/.el-input__prefix {
// 	right: -530px !important;
// 	font-size: 18px;
// }
.ul_rate {
	display: flex;
	justify-content: space-around;
}
.textarea {
	width: 600px;
	border: 1px solid #ccc !important;
}
input:hover {
	border: 1px dashed #ccc;
}
.computerBox {
	width: 100%;
	min-height: 300px;
	background: #fff;
	margin: 0 auto;
}
.search {
	width: 28px;
	height: 28px;
	background: rgba(0, 0, 0, 0.3);
	border-radius: 50%;
	cursor: pointer;
	position: absolute;
	right: 0;
	top: 0;
}
.search i {
	color: #fff;
}
.preview_img {
	flex: 1;
	height: 220px;
	border: 1px solid #ccc;
	position: relative;
}
.topicBox {
	padding: 0 20px;
	height: 40px;
	border: 1px solid #ccc;
	margin-bottom: 5px;
}
.defultBox {
	background: #e0e9ff;
	border: 1px solid #0080ff;
}
.p-title {
	font-size: 16px;
	margin-top: 15px;
}
.title {
	font-size: 20px;
	color: #333;
}
.phone-bj-box {
	height: 721px;
	border-radius: 18px;
	overflow-y: scroll;
	scrollbar-width: none;
	-ms-overflow-style: none;
	overflow-x: hidden;
}
.phone-bj-box::-webkit-scrollbar {
	width: 0;
}
.ipad-bj-box {
	width: 82%;
	height: 510px;
	overflow-y: scroll;
	margin-top: 35px;
	margin-left: 92px;
}
.header {
	width: 100%;
	height: 70px;
	background: #fff;
	padding: 0 20px;
	position: fixed;
	top: 0;
	z-index: 112;
    box-sizing: border-box;
}
.header-back {
	height: 100%;
	cursor: pointer;
	padding: 0px 0px 0px 20px;
}
.header-back i {
	font-size: 20px;
	cursor: pointer;
}
.header-back span {
	margin-left: 20px;
}
.tab {
	width: 100%;
	height: 100px;
	background: #f5f5f5;
	position: fixed;
	top: 70px;
	z-index: 112;
	.tab_button {
		position: absolute;
		top: 35px;
	}
}
.tab div {
	position: absolute;
	top: 30px;
}
.pb {
	transform: rotate(-90deg);
	-ms-transform: rotate(-90deg); /* IE 9 */
	-moz-transform: rotate(-90deg); /* Firefox */
	-webkit-transform: rotate(-90deg); /* Safari 和 Chrome */
	-o-transform: rotate(-90deg);
}
.phoneBox {
	padding-top: 180px;
}
.phone-bj {
	width: 375px;
	border-radius: 25px;
	border: 5px solid #ccc;
	// width: 379px;
	// height: 756px;
	// background: url('../../assets/iphone.png') no-repeat center;
	// background-size: 100% 100%;
	// overflow: hidden;
}
.ipadBox {
	width: 816px;
	height: 576px;
	background: url('../../assets/ipad.png') no-repeat center;
	background-size: 100% 100%;
	margin: 0 auto;
	overflow: hidden;
	margin-top: 30px;
}
table,
table td,
table th {
	border: 1px solid gray;
	border-collapse: collapse;
}
tr {
	height: 30px;
}
.td_width {
	width: 150px;
}
.map {
	width: 500px;
	height: 300px;
}
/deep/ .area-select .area-selected-trigger {
	padding: 0 !important;
}
.StarsWrap {
	width: 100%;
	height: 0.2rem;
	margin: 0.1rem 0;
}
.StarsWrap li {
	float: left;
	margin-right: 0.1rem;
}
.aaaaa .questCity {
	width: 120px;
	float: left;
	margin-right: 20px;
}
.ditu {
	position: relative;
}
.tip {
	position: absolute;
	top: 0;
	left: 0;
}
#tip {
	top: 0;
}
#search {
	width: 200px;
	height: 30px;
	margin-top: 7px;
}
#tip .span1 {
	display: block;
	width: 50px;
	height: 50px;
	float: right;
	line-height: 50px;
}
</style>
